import React from 'react'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button'
import { Text } from '@wartek-id/text'
import {
  Sheet,
  SheetOverlay,
  SheetContent,
  SheetTitle,
  SheetCloseButton,
  SheetBody,
} from '@wartek-id/sheet'
import { Textarea } from '@wartek-id/textarea'

import { AppealState } from 'types/microlearning'
import { usePostAksiNyataAppeal } from 'api/microlearning/useAPITopics'

import type { TAPIGetAksiNyataRevisionResponse } from 'types/microlearning'

type TAppealSheetProps = {
  appeal: TAPIGetAksiNyataRevisionResponse['appeal']
  isOpen: boolean
  setIsOpen: Function
  onAppealSubmitted: Function
}
const AppealSheet = ({
  appeal,
  isOpen,
  setIsOpen,
  onAppealSubmitted,
}: TAppealSheetProps) => {
  const [appealText, setAppealText] = React.useState('')
  const router = useRouter()
  const topicId = router.query.topik as string

  const { mutateAsync: postAksiNyataMutateAsync, isLoading } =
    usePostAksiNyataAppeal(topicId, {
      onSuccess: () => onAppealSubmitted(),
    })

  const handleSubmitAppeal = async () => {
    // if appeal state is not NotCreated or Declined, then forbid submit
    if (![AppealState.NotCreated, AppealState.Declined].includes(appeal.state))
      return

    await postAksiNyataMutateAsync({
      appeal: appealText,
    })

    setIsOpen(false)
  }

  return (
    <Sheet isOpen={isOpen} onClose={setIsOpen}>
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <SheetTitle bordered>
          <Text variant="heading-sm">Pengajuan Banding</Text>
        </SheetTitle>
        <SheetCloseButton />
        <SheetBody>
          <div className="p-4">
            <Text>Mengapa Anda tidak setuju dengan saran perbaikan ini?</Text>
            <Textarea
              data-testid="textarea"
              className="mt-1 mb-4"
              placeholder="Contoh: Mengenai saran agar saya menyertakan umpan balik. Saya tidak setuju karena saya telah menyertakan umpan balik dalam bentuk tautan. Mohon dicek ulang."
              value={appealText}
              onChange={(e) => {
                setAppealText(e.target.value)
              }}
              maxLength={500}
            />
            <Button
              data-testid="submit-button"
              color="black"
              fullWidth
              size="lg"
              onClick={handleSubmitAppeal}
              disabled={appealText === '' || isLoading}
            >
              Ajukan banding
            </Button>
          </div>
        </SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default AppealSheet
